(ns io.daskul.tutorial.webapp.shared.api.client
  "HTTP client utilities for API requests.

  Provides API base URL from config. Auth header can be added later."
  (:require
   [io.daskul.api-contract.active-context :as actx]
   [io.daskul.tutorial.webapp.config :as config]))

(def api-url
  "Base URL for Tutorial API from config."
  (config/api-url))

(defn active-context-headers
  "Active context headers for ACTIVE-CTX, named by the shared contract (F-041).

   Split out of auth-header as a pure fn so it is unit-testable without
   stubbing localStorage.

   SMS-279: when there is an active context but no branch selected, that is
   'All Branches' by choice — send an explicit All-Branches header so the
   backend resolves a nil active branch. Without it, 'no branch header' is
   ambiguous and the backend falls back to the JWT primary branch."
  [active-ctx]
  (cond-> {}
    (:school-id active-ctx) (assoc (:school-id actx/header) (:school-id active-ctx))
    (:branch-id active-ctx) (assoc (:branch-id actx/header) (:branch-id active-ctx))
    (and active-ctx (not (:branch-id active-ctx)))
    (assoc (:all-branches actx/header) actx/all-branches-value)))

(defn auth-header
  "Get Authorization + Active Context headers for API requests.
   Active context headers tell the backend which branch/school
   the user is currently working in (F-041)."
  []
  (when-let [token (.getItem js/localStorage "auth-token")]
    (let [active-ctx (try
                       (when-let [raw (.getItem js/localStorage "active-context")]
                         (js->clj (js/JSON.parse raw) :keywordize-keys true))
                       (catch :default _ nil))]
      (merge {"Authorization" (str "Bearer " token)}
             (active-context-headers active-ctx)))))
